import React from "react";
import { Typography } from "@mui/material";
import { Section, Link } from "@arp/react-ndbx";

//** Context */
import usePreQualificationPages from "../../hooks/usePreQualificationPages";
import { PATH_ONLINE } from "../../routes/paths";

export default function YourDetailsHeader({ ...props }) {
  const { state } = usePreQualificationPages();
  const { currentPage } = { ...state };
  const { href = PATH_ONLINE.retrieveQuote, isOnline = true } = {
    ...props,
  };

  return (
    <>
      <Section
        controlIdentifier={currentPage.identifier}
        ariaLabel={currentPage.title}
        mb={2}
      >
        <Typography variant="h2-bold">Allianz Life Plan Quote</Typography>
      </Section>
      <Section>
        {isOnline ? (
          <Section>
            <Typography variant="p2-bold">
              We just need a few details to get things started.
            </Typography>
          </Section>
        ) : null}
        <Section md={10} sx={{ outline: "0px solid red" }}>
          <Typography variant="p3">Already saved an application?</Typography>
          <Link href={href}>Retrieve your saved application.</Link>
        </Section>
      </Section>
    </>
  );
}
